module.exports = __webpack_public_path__ + "img/ice-drink.d7d8d1f6.svg";